import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const container = document.querySelector('.service-slider');
const desktopSmallMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.desktopSmall}px)`);

export const mainServiceSlider = () => {
	const slider =
		container &&
		new Swiper(container, {
			modules: [Autoplay, Pagination],
			slidesPerView: 'auto',
			allowTouchMove: true,
			grabCursor: true,
			slidesOffsetBefore: 16,
			slidesOffsetAfter: 16,
			spaceBetween: 20,
			pagination: {
				el: container?.querySelector('.swiper-pagination'),
				clickable: true,
			},
			init: false,
		});

	if (!slider) {
		return;
	}

	const onMediaChange = () => {
		if (!desktopSmallMQ.matches) {
			slider.init();
			slider.enable();
		} else {
			slider.disable();
		}
	};

	!desktopSmallMQ.matches && slider.init();

	desktopSmallMQ.addEventListener('change', onMediaChange);
};

export const mainServiceFlipCards = () => {
	const resetFlips = () => {
		document.querySelectorAll('.js-service-card-flip').forEach((flipRoot) => {
			flipRoot.classList.remove('is-flipped');
		});
	};

	const onMediaChange = () => {
		if (desktopSmallMQ.matches) {
			resetFlips();
		}
	};

	const attachFlip = (flipRoot) => {
		const front = flipRoot.querySelector('.js-service-card-flip-front');
		const closeBtn = flipRoot.querySelector('.js-service-card-flip-close');

		const onFlipFrontClick = () => {
			if (desktopSmallMQ.matches) {
				return;
			}
			flipRoot.classList.add('is-flipped');
		};

		const onFlipCloseClick = (event) => {
			event.stopPropagation();
			if (desktopSmallMQ.matches) {
				return;
			}
			flipRoot.classList.remove('is-flipped');
		};

		front?.addEventListener('click', onFlipFrontClick);
		closeBtn?.addEventListener('click', onFlipCloseClick);
	};

	document.querySelectorAll('.js-service-card-flip').forEach(attachFlip);

	desktopSmallMQ.addEventListener('change', onMediaChange);
};

const serviceModalSelector = '#modal-service-card';

const buildServiceModalHtml = (flipRoot) => {
	const titleLink = flipRoot.querySelector('.service-item__title--flip-modal');
	const fromDataset = titleLink?.dataset?.title?.trim() ?? '';
	const titleHtml =
		fromDataset ||
		(flipRoot.querySelector('.service-item-flip-back__title')?.innerHTML?.trim() ?? '');

	const iconWrap = flipRoot.querySelector('.js-service-card-flip-front .service-item__icon');
	const iconHtml = iconWrap?.innerHTML ?? '';

	const bodyEl = flipRoot.querySelector('.service-item-flip-back__content');
	const bodyHtml = bodyEl?.innerHTML ?? '';

	return `<div class="service-card-modal"><div class="service-card-modal__header"><div class="service-card-modal__icon">${iconHtml}</div><p class="service-card-modal__title">${titleHtml}</p></div><div class="service-item-flip-back__content content service-card-modal__body">${bodyHtml}</div></div>`;
};

export const mainServiceCardModal = () => {
	const modalEl = document.querySelector(serviceModalSelector);
	if (!modalEl) return;

	const onCardModalOpenerClick = (event) => {
		const flip = event.currentTarget.closest('.js-service-card-flip');
		if (!flip) return;
		window.app.classInstance.get(modalEl)?.modal?.content(buildServiceModalHtml(flip));
	};

	const openerSelector = `.js-modal-open[data-modal="${serviceModalSelector}"]`;

	document.querySelectorAll(openerSelector).forEach((opener) => {
		opener.addEventListener('click', onCardModalOpenerClick);
	});

	const closeServiceModal = () => {
		if (desktopSmallMQ.matches || !modalEl.classList.contains('active')) return;
		window.app?.modal?.close();
	};

	desktopSmallMQ.addEventListener('change', closeServiceModal);
};
